import React from 'react';
import $ from "jquery";

class MyJeevaAppUsage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timeView: 'monthly',
            patientFilter: 'myPatients',
            expandedMonths: [],
            expandedWeeks: [],
            activityData: [], 
            loading: false,
        };

        this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    }

    componentDidMount() {
        this.fetchAppUsageData();
    }

    handleTimeViewChange = (e) => {
        this.setState(
            { timeView: e.target.value, expandedMonths: [], expandedWeeks: [], activityData: [] },
            () => this.fetchAppUsageData()
        );
    };

    // Re-fetch whenever filter changes
    handlePatientFilterChange = (e) => {
        this.setState(
            { patientFilter: e.target.value, expandedMonths: [], expandedWeeks: [], activityData: [] },
            () => this.fetchAppUsageData()
        );
    };

    fetchAppUsageData = () => {
        const { timeView, patientFilter } = this.state;

        let filterId;
        let filter;

        if (patientFilter === "myPatients") {
            filterId = this.userDetails["userId"];
            filter = "provider";
        } else if (patientFilter === "allDepartmentPatients") {
            filterId = this.userDetails["serviceLineId"];
            filter = "department";
        } else {
            filterId = this.userDetails["hospitalId"];
            filter = "hospital";
        }

        this.setState({ loading: true });

        $.ajax({
            url: "/my-jeeva-api/app-usage-activity",
            type: "GET",
            data: {
                filterId: filterId,
                view: timeView,
                filter: filter,
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: (response) => {
                if (response.success) {
                    this.setState({ activityData: response.result || [], loading: false });
                } else {
                    this.setState({ activityData: [], loading: false });
                }
            },
            error: (xhr) => {
                console.error(xhr);
                this.setState({ activityData: [], loading: false });
            },
        });
    };

    toggleMonthExpansion = (period) => {
        this.setState((prevState) => {
            const expanded = prevState.expandedMonths.includes(period);
            return {
                expandedMonths: expanded
                    ? prevState.expandedMonths.filter((m) => m !== period)
                    : [...prevState.expandedMonths, period],
            };
        });
    };

    toggleWeekExpansion = (period) => {
        this.setState((prevState) => {
            const expanded = prevState.expandedWeeks.includes(period);
            return {
                expandedWeeks: expanded
                    ? prevState.expandedWeeks.filter((w) => w !== period)
                    : [...prevState.expandedWeeks, period],
            };
        });
    };

    linkToManageTab = (patient) => {
        localStorage.setItem("patientId", patient.patientId);
        localStorage.setItem("patientName", patient.patientName);
        localStorage.setItem("activeTabOnLoad", "appUsage");

        this.props.history.push("/projectmgmt/patient-admission/manage-admission");
    };

    formatDate = (dateStr) => {
        const [year, month, day] = dateStr.split('/');
        return `${month}/${day}/${year}`;
    };

    renderMonthlyView = () => {
        const { expandedMonths, loading } = this.state;
        const activityData = this.state.activityData || [];

        if (loading) {
            return (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>Loading ...</p>
                </div>
            );
        }

        return (
            <div style={{ backgroundColor: 'white', borderRadius: '4px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#667eea' }}>
                            <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: '600', borderBottom: '1px solid #e0e0e0', fontSize: '13px', color: 'white' }}>Month / Year</th>
                            <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid #e0e0e0', fontSize: '13px', color: 'white' }}>&lt;30 min</th>
                            <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid #e0e0e0', fontSize: '13px', color: 'white' }}>30-44 min</th>
                            <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid #e0e0e0', fontSize: '13px', color: 'white' }}>45-59 min</th>
                            <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid #e0e0e0', fontSize: '13px', color: 'white' }}>60+ min</th>
                        </tr>
                    </thead>
                    <tbody>
                        {activityData.length === 0 ? (
                            <tr>
                                <td colSpan="5" style={{ padding: '40px', textAlign: 'center', color: '#888', fontSize: '13px' }}>
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            activityData.map((item) => (
                                <React.Fragment key={item.period}>

                                    {/* Month summary row */}
                                    <tr
                                        onClick={() => this.toggleMonthExpansion(item.period)}
                                        style={{ backgroundColor: '#f9f9fb', cursor: 'pointer', borderBottom: '1px solid #e0e0e0', transition: 'background-color 0.2s ease' }}
                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f5'}
                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f9f9fb'}
                                    >
                                        <td style={{ padding: '12px 16px', fontWeight: '500', color: '#2d3748', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ fontSize: '14px', color: '#667eea' }}>
                                                {expandedMonths.includes(item.period) ? '▼' : '▶'}
                                            </span>
                                            {item.periodName}
                                        </td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center', fontWeight: '600', color: '#2d3748', fontSize: '13px' }}>{item.lessThan30}</td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center', fontWeight: '600', color: '#2d3748', fontSize: '13px' }}>{item.between30_44}</td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center', fontWeight: '600', color: '#2d3748', fontSize: '13px' }}>{item.between45_59}</td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center', fontWeight: '600', color: '#2d3748', fontSize: '13px' }}>{item.sixtyPlus}</td>
                                    </tr>

                                    {/* Expanded: patient rows directly in outer tbody */}
                                    {expandedMonths.includes(item.period) && (
                                        item.patients.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" style={{ padding: '20px', textAlign: 'center', color: '#888', fontSize: '13px', backgroundColor: '#f5f5f5' }}>
                                                    No patient activity this month
                                                </td>
                                            </tr>
                                        ) : (
                                            item.patients.map((patient, idx) => (
                                                <tr
                                                    key={patient.patientId}
                                                    style={{ backgroundColor: idx % 2 === 0 ? '#ffffff' : '#f9f9fb', borderBottom: '1px solid #e0e0e0' }}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e8eaf6'}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = idx % 2 === 0 ? '#ffffff' : '#f9f9fb'}
                                                >
                                                    <td
                                                        style={{ padding: '10px 16px', paddingLeft: '40px', color: "#007bff", fontSize: '13px', cursor: 'pointer' }}
                                                        onClick={() => this.linkToManageTab(patient)}
                                                    >
                                                        {patient.patientName}
                                                    </td>
                                                    <td style={{ padding: '10px 16px', textAlign: 'center', color: '#2d3748', fontSize: '13px' }}>{patient.lessThan30}</td>
                                                    <td style={{ padding: '10px 16px', textAlign: 'center', color: '#2d3748', fontSize: '13px' }}>{patient.between30_44}</td>
                                                    <td style={{ padding: '10px 16px', textAlign: 'center', color: '#2d3748', fontSize: '13px' }}>{patient.between45_59}</td>
                                                    <td style={{ padding: '10px 16px', textAlign: 'center', color: '#2d3748', fontSize: '13px' }}>{patient.sixtyPlus}</td>
                                                </tr>
                                            ))
                                        )
                                    )}
                                </React.Fragment>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        );
    };

    renderWeeklyView = () => {
        const { expandedWeeks, loading } = this.state;
        const activityData = this.state.activityData || [];

        if (loading) {
            return (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>Loading ...</p>
                </div>
            );
        }

        return (
            <div style={{ backgroundColor: 'white', borderRadius: '4px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#667eea' }}>
                            <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: '600', borderBottom: '1px solid #e0e0e0', fontSize: '13px', color: 'white' }}>Week (MM/DD/YYYY)</th>
                            <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid #e0e0e0', fontSize: '13px', color: 'white' }}>&lt;30 min</th>
                            <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid #e0e0e0', fontSize: '13px', color: 'white' }}>30-44 min</th>
                            <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid #e0e0e0', fontSize: '13px', color: 'white' }}>45-59 min</th>
                            <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid #e0e0e0', fontSize: '13px', color: 'white' }}>60+ min</th>
                        </tr>
                    </thead>
                    <tbody>
                        {activityData.length === 0 ? (
                            <tr>
                                <td colSpan="5" style={{ padding: '40px', textAlign: 'center', color: '#888', fontSize: '13px' }}>
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            activityData.map((item) => (
                                <React.Fragment key={item.period}>

                                    {/* Week summary row */}
                                    <tr
                                        onClick={() => this.toggleWeekExpansion(item.period)}
                                        style={{ backgroundColor: '#f9f9fb', cursor: 'pointer', borderBottom: '1px solid #e0e0e0', transition: 'background-color 0.2s ease' }}
                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f5'}
                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f9f9fb'}
                                    >
                                        <td style={{ padding: '12px 16px', fontWeight: '500', color: '#2d3748', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ fontSize: '14px', color: '#667eea' }}>
                                                {expandedWeeks.includes(item.period) ? '▼' : '▶'}
                                            </span>
                                            {this.formatDate(item.periodName)}                                        </td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center', fontWeight: '600', color: '#2d3748', fontSize: '13px' }}>{item.lessThan30}</td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center', fontWeight: '600', color: '#2d3748', fontSize: '13px' }}>{item.between30_44}</td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center', fontWeight: '600', color: '#2d3748', fontSize: '13px' }}>{item.between45_59}</td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center', fontWeight: '600', color: '#2d3748', fontSize: '13px' }}>{item.sixtyPlus}</td>
                                    </tr>

                                    {/* Expanded: patient rows directly in outer tbody */}
                                    {expandedWeeks.includes(item.period) && (
                                        item.patients.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" style={{ padding: '20px', textAlign: 'center', color: '#888', fontSize: '13px', backgroundColor: '#f5f5f5' }}>
                                                    No patient activity this week
                                                </td>
                                            </tr>
                                        ) : (
                                            item.patients.map((patient, idx) => (
                                                <tr
                                                    key={patient.patientId}
                                                    style={{ backgroundColor: idx % 2 === 0 ? '#ffffff' : '#f9f9fb', borderBottom: '1px solid #e0e0e0' }}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e8eaf6'}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = idx % 2 === 0 ? '#ffffff' : '#f9f9fb'}
                                                >
                                                    <td
                                                        style={{ padding: '10px 16px', paddingLeft: '40px', color: "#007bff", fontSize: '13px', cursor: 'pointer' }}
                                                        onClick={() => this.linkToManageTab(patient)}
                                                    >
                                                        {patient.patientName}
                                                    </td>
                                                    <td style={{ padding: '10px 16px', textAlign: 'center', color: '#2d3748', fontSize: '13px' }}>{patient.lessThan30}</td>
                                                    <td style={{ padding: '10px 16px', textAlign: 'center', color: '#2d3748', fontSize: '13px' }}>{patient.between30_44}</td>
                                                    <td style={{ padding: '10px 16px', textAlign: 'center', color: '#2d3748', fontSize: '13px' }}>{patient.between45_59}</td>
                                                    <td style={{ padding: '10px 16px', textAlign: 'center', color: '#2d3748', fontSize: '13px' }}>{patient.sixtyPlus}</td>
                                                </tr>
                                            ))
                                        )
                                    )}
                                </React.Fragment>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        );
    };

    render() {
        const { timeView, patientFilter } = this.state;

        const patientFilterOptions = [
            { value: 'myPatients', label: 'Only my patients' },
            { value: 'allDepartmentPatients', label: 'All patients in my department' },
            { value: 'allHospitalPatients', label: 'All patients in my hospital' },
        ];

        const timeViewOptions = [
            { value: 'monthly', label: 'Monthly' },
            { value: 'weekly', label: 'Weekly' },
        ];

        return (
            <div style={{ padding: '20px', backgroundColor: '#f5f5f5', minHeight: '100vh', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                <link rel="stylesheet" href="assets/css/JeevaAppUsage.css" />
                <link rel="stylesheet" href="assets/css/adminlte.css" />

                {/* Header with Controls */}
                <div style={{ backgroundColor: 'white', borderRadius: '4px', padding: '20px', marginBottom: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                    <h1 style={{ margin: '0 0 16px 0', fontSize: '24px', fontWeight: '600', color: '#1a202c' }}>MyJeeva App Usage</h1>

                    <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
                        <div>
                            <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '500', color: '#2d3748' }}>View</label>
                            <select
                                value={timeView}
                                onChange={this.handleTimeViewChange}
                                style={{ height: '32px', borderRadius: '4px', backgroundColor: '#F9F9FB', width: '140px', border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', cursor: 'pointer', fontFamily: 'inherit', color: '#2d3748' }}
                            >
                                {timeViewOptions.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '500', color: '#2d3748' }}>Patient Filter</label>
                            <select
                                value={patientFilter}
                                onChange={this.handlePatientFilterChange}
                                style={{ height: '32px', borderRadius: '4px', backgroundColor: '#F9F9FB', width: '280px', border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', cursor: 'pointer', fontFamily: 'inherit', color: '#2d3748' }}
                            >
                                {patientFilterOptions.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                {/* Main Table */}
                <div>
                    {timeView === 'monthly' ? this.renderMonthlyView() : this.renderWeeklyView()}
                </div>
            </div>
        );
    }
}

export default MyJeevaAppUsage;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/MyJeevaAppUsage.js